import { CSSProperties, useEffect, useRef } from 'react';
import { useMounted } from '../../../hooks/useMounted';

interface TableProps {
    className?: string,
    children?: React.ReactNode,
    onResize?: (w: number) => void,
    style?: CSSProperties
}

function Table({ className, children, onResize, style }: TableProps) {
    const ref = useRef<HTMLDivElement>(null);
    const isMounted = useMounted();

    useEffect(() => {
        if (!isMounted) return;
        if (!ref.current) return; // wait for the elementRef to be available

        const resizeObserver = new ResizeObserver(() => {
            if (ref.current) {
                onResize &&  onResize(ref.current.clientWidth);
            }
        });
        resizeObserver.observe(ref.current);
        return () => resizeObserver.disconnect(); // clean up 
    }, [isMounted]);

    return (
        <div className="table-list__wrapper">
            <div ref={ref} className={'table-list ' + (className || '')} style={style}>
                {children}
            </div>
        </div>
    );
}

export default Table;
